import { constants } from '@/utils/Constants.js'

import store from '../store/store'

export const ignoreTargeting = (objective, type) => {

  let hasFeature = (...features) => {
    // if user didn't pass any permissions
    if (!features) {
      return false
    }

    // reserved keyword to show section to anybody
    if (features[0] === 'all') {
      return true
    }

    // get current account
    const activeAccount = store.getters['authentication/activeAccount']

    // check if there is any permissions at all
    // eslint-disable-next-line no-extra-boolean-cast
    if (!activeAccount.features) {
      return false
    }

    // loop over permissions array and check them all
    for (const feature of features) {
      // check if permission in current.permissions array
      if (activeAccount.features.indexOf(feature) === -1) {
        return false
      }
    }

    return true
  }

  const objectivesNotAllowedToHavePlatforms = [
    constants.CAMPAIGN_OBJECTIVES_NAMES.CONVERSIONS,
    constants.CAMPAIGN_OBJECTIVES_NAMES.LEAD_FORM
  ]

  return (objectivesNotAllowedToHavePlatforms.includes(objective) || type === constants.CAMPAIGN_TYPES_NAMES.INLINE) && !hasFeature('lead_form_custom_questions')
}

export const ignoreTargetingBackup = (objective, type) => {
  const objectivesNotAllowedToHavePlatforms = [
    constants.CAMPAIGN_OBJECTIVES_NAMES.CONVERSIONS,
    constants.CAMPAIGN_OBJECTIVES_NAMES.LEAD_FORM
  ]

  return (objectivesNotAllowedToHavePlatforms.includes(objective) || type === constants.CAMPAIGN_TYPES_NAMES.INLINE)
}
